import fieldComponentizer from './component/fieldComponentizer';
import elementComponentizer from './component/elementComponentizer';

export default angular.module('edge.platform.widgets.componentizer', ['portal.config'])
    .component('gwElementComponentizer', elementComponentizer)
    .component('gwFieldComponentizer', fieldComponentizer);